module.exports = __webpack_public_path__ + "img/id.f6ed266d.svg";